module.exports = __webpack_public_path__ + "static/work2-fc73682f4d89ccce655529ec5f6f6eb8.jpg";